import Raven from 'raven-js';

import { sentry_config } from '../globals';
import store from '../store';


export type SeverityLevel = "fatal" | "error" | "warning" | "info" | "debug";



export function sentry_log(error: Error, error_level = "error", extra_scope?: any) {
  console.error(error)
  if (sentry_config.use_sentry) {
    const state = store.getState()
    const username = state.login.logged_in ?
      state.login.user.user.username :
      "Anonymous";
    Raven.setUserContext({
      username,
    });
    Raven.setExtraContext(extra_scope);
    Raven.captureException(error, {
      level: error_level as SeverityLevel,
    });
    Raven.setExtraContext();
  }
}
